import { useUIStore } from '@/stores';
import { useIsMobile } from '@/hooks/useMediaQuery';
import { Navbar } from './Navbar';
import { Sidebar } from './Sidebar';
import { MobileNav } from './MobileNav';
import { ToastContainer, SkipLink } from '@/components/common';
import { DebugModeSwitcher } from '@/components/debug';
import styles from './Layout.module.css';

interface LayoutProps {
  children: React.ReactNode;
}

export function Layout({ children }: LayoutProps) {
  const isMobile = useIsMobile();
  const { mobileNavOpen, setMobileNavOpen, sidebarCollapsed } = useUIStore();
  
  return (
    <div className={styles.layout}>
      <SkipLink targetId="main-content" />
      <Navbar onMenuClick={() => setMobileNavOpen(true)} />
      
      {isMobile ? (
        <MobileNav
          isOpen={mobileNavOpen}
          onClose={() => setMobileNavOpen(false)}
        />
      ) : (
        <Sidebar collapsed={sidebarCollapsed} />
      )}
      
      <main
        id="main-content"
        className={styles.main}
        tabIndex={-1}
        style={{
          marginLeft: isMobile
            ? 0
            : sidebarCollapsed
            ? 'var(--sidebar-collapsed-width)'
            : 'var(--sidebar-width)',
        }}
      >
        <div className={styles.content}>{children}</div>
      </main>
      
      <ToastContainer />
      <DebugModeSwitcher />
    </div>
  );
}
